__turbopack_context__.v({
  "calendar": "calendar-module__1JxLvW__calendar",
  "dayButton": "calendar-module__1JxLvW__dayButton",
  "navigationSelect": "calendar-module__1JxLvW__navigationSelect",
});
